export default "__VITE_ASSET__677076e3__"